import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {NgForm, NgModel} from '@angular/forms';
import {
  DateControl,
  firstNestedSymbolControl,
  getHTMLControlName,
  hasGruppeTechnischeSteuerung, UIArtefakt,
  Wertemenge
} from '../../../models/uiArtefakt';
import {ValidationService} from '../../../services/validation.service';
import {UiUpdateService} from '../../../services/ui-update.service';
import {UIDarstellungsart} from '../../../models/uiDarstellungsart';
import {WertemengenService} from '../../../services/wertemengen.service';
import {ISymbol, TranslationService, RuntimeContext} from '@lv1871/core';
import {ShellConfigService} from '../../../services/shell-config.service';
import {UIAusrichtung} from '../../../models/uiAusrichtung';
import {v4 as uuid} from 'uuid';
import {EventService} from '../../../services/event.service';
import {EnumGruppeTechnischeSteuerung, hasAvvEinwilligung} from '../../../models/enumGruppeTechnischeSteuerung';
import {MeldungPipe} from '../../../pipes/meldung.pipe';

@Component({
    selector: 'lv-radio-group',
    templateUrl: './radio-group.component.html',
    styleUrls: ['./radio-group.component.scss'],
    providers: [WertemengenService, MeldungPipe],
    standalone: false
})
export class RadioGroupComponent implements OnInit, AfterViewInit {
  @ViewChild(NgForm, {static: true})
  private _ngForm;

  @ViewChild('radioGroup', {static: true})
  private _radioGroup: NgModel;

  public loadedOptions$;
  public isDisabled: boolean = false;
  public showUntruncatedError: boolean = false;
  public uiAusrichtung: UIAusrichtung;
  public nestedSymbol: ISymbol;
  public isRadioGroupInline: boolean = false;
  public showInfotextCollapsable: boolean = false;
  public controlName: string;
  public isSBShell: boolean;
  public uniqueId: any;

  private _uiArtefakt: Wertemenge;

  constructor(private _validationService: ValidationService,
              private _shellConfigService: ShellConfigService,
              private _translationService: TranslationService,
              private _uiUpdateService: UiUpdateService,
              private _wertemengenService: WertemengenService,
              private _eventService: EventService,
              private _meldungPipe: MeldungPipe,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): Wertemenge {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: Wertemenge) {
    this._uiArtefakt = uiArtefakt;
    this.isDisabled = this._uiArtefakt?.Darstellungsart === UIDarstellungsart.DISABLED ||
        !hasAvvEinwilligung(hasGruppeTechnischeSteuerung(
                this.uiArtefakt, EnumGruppeTechnischeSteuerung.AVVEINWILLIGUNG),
            this._eventService.avvEinwilligungImAntrag$.getValue(),
            this._eventService.vermittlerdatenFuerAvvGesetzt$.getValue());
  }

  public infotextCollapsableChange(event) {
    this.showInfotextCollapsable = event;
  }

  public ngOnInit(): void {
    this.loadedOptions$ = this._wertemengenService.filteredOptions$;
    this.isSBShell = this._shellConfigService.getParameter().runtimeContext === RuntimeContext.SB_SHELL;
    this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
    this.nestedSymbol = firstNestedSymbolControl(this.uiArtefakt.UIArtefakt);
    this.isRadioGroupInline = this.uiArtefakt.WertemengeComponent === 'RadioGroupInline';
    this._validationService.registerForm(this.uiArtefakt, this._ngForm);
    this._wertemengenService.filterWertemenge(this.uiArtefakt, '');
    this.controlName = getHTMLControlName(this.uiArtefakt);
    this.uniqueId = uuid();
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  changeSelection(selection: string) {
    this.uiArtefakt.WertEingabe = selection;
    this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
    if(!!this._uiArtefakt.ReferenzIdentifikator){
      this._eventService.refIdentTouchedOrDirty$.next(this._uiArtefakt.ReferenzIdentifikator);
    }
  }

  public getError(): string {
    if (this.uiArtefakt.PflichtfeldJN && this._ngForm.form.status !== 'VALID' && this._ngForm.form?.touched) {
      const requiredError = this._translationService.translate('ERRORS.REQUIRED');
      return !!this.uiArtefakt.FehlertextPflichtfeld ? this.uiArtefakt.FehlertextPflichtfeld : requiredError;
    }
    if (this.uiArtefakt.UIMeldung?.length && this._radioGroup?.touched) {
      return this._meldungPipe.getMostImportantMeldungstext(this.uiArtefakt.UIMeldung);
    }
    this.showUntruncatedError = false;
    return null;
  }

  public onErrorClick() {
    this.showUntruncatedError = !this.showUntruncatedError;
  }
}
